import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ConfirmService } from './features/confirm';
import { SharedModule } from './shared/shared.module';
import { PublicCardModule } from './ui/public-card/public-card.module';
//import { RouterModule, Routes } from '@angular/router';
@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    ToastrModule.forRoot( ),
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PublicCardModule,
    NgxMaskModule.forRoot( ),
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient],
  
      },
      
    }),

    TransferHttpCacheModule,
  ],
  providers: [ConfirmService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
